export { clearTimer, setTimer } from './actions';
export { reducer } from './reducer';
export { getIsTimerRunning, getTimer } from './selectors';
